import {useEventListener} from '../../../hooks/useEventListener';

export const useFontsLoadedListener = (listener: (event: Event) => void) => {
  useEventListener(document.fonts, 'loadingdone', listener);
};
